import { gql } from "@apollo/client";

export const PAT_SUBMIT_FOR_PAYMENT_MUTATION = gql`
  mutation PATSubmitForPayment($id: ID!, $examinerFeePayee: String!) {
    patSubmitForPayment(id: $id, examinerFeePayee: $examinerFeePayee) {
      message
      success
    }
  }
`;

export const CREATE_EXPENSE_DOCUMENT_UPLOAD_MUTATION = gql`
  mutation createExpenseDocumentUpload($eventId: ID!, $file: Upload!, $name: String!) {
    createExpenseDocumentUpload(eventId: $eventId, file: $file, name: $name) {
      message
    }
  }
`;

export const EXPENSE_DOCUMENTS_QUERY = gql`
  query ExpenseDocuments(
    $eventId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: BackofficePATExpenseDocumentsOrderByInput
  ) {
    expenseDocuments(eventId: $eventId, first: $first, after: $after, last: $last, before: $before, orderBy: $orderBy) {
      edges {
        cursor
        node {
          id
          name
          filename
          url
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const DELETE_EXPENSE_DOCUMENT_MUTATION = gql`
  mutation deleteExpenseDocument($id: ID!) {
    deleteExpenseDocument(id: $id) {
      message
      success
    }
  }
`;
